import { NgModule, APP_INITIALIZER, APP_BOOTSTRAP_LISTENER } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpModule } from '@angular/http';
import { Router } from '@angular/router';
import { groupBy } from 'lodash';

import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { Ng2PageScrollModule } from 'ng2-page-scroll';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';

import { NavigationService } from './navigation.service';
import { ApiService } from './api.service';
import { RoutingService } from './routing.service';
import { BreakpointsService } from './breakpoints.service';
import { ImageGalleryService } from './image-gallery.service';
import { LayoutService } from './layout.service';
import { CursorService } from './cursor.service';
import { requestOptionsProvider } from './default-request-options.service';
import { SplashService } from './splash.service';
import { MyHammerConfig } from './hammer.config';
import { HAMMER_GESTURE_CONFIG } from '@angular/platform-browser';

import { ImageComponent } from './image/image.component';
import { PageComponent } from './page/page.component';
import { SplashPageComponent } from './splash-page/splash-page.component';
import { NavBarComponent } from './nav-bar/nav-bar.component';
import { HomeViewComponent } from './home-view/home-view.component';
import { PosterImageComponent } from './poster-image/poster-image.component';
import { HoverDirective } from './hover.directive';
import { ProjectViewComponent } from './project-view/project-view.component';
import { DefaultPageViewComponent } from './default-page-view/default-page-view.component';
import { TableViewComponent } from './table-view/table-view.component';
import { GridViewComponent } from './grid-view/grid-view.component';
import { ThreeColViewComponent } from './three-col-view/three-col-view.component';
import { ImageGalleryViewComponent } from './image-gallery-view/image-gallery-view.component';
import { ContentBlocksComponent } from './content-blocks/content-blocks.component';
import { SidebarComponent } from './sidebar/sidebar.component';
import { PosterComponent } from './poster/poster.component';
import { MessageOverlayComponent } from './message-overlay/message-overlay.component';
import { ViewWithNavBarComponent } from './view-with-nav-bar/view-with-nav-bar.component';

export function init_app(routingService: RoutingService, navigationService: NavigationService){
    // Do initing of services that is required before app loads
    // NOTE: this factory needs to return a function (that then returns a promise)
    return (): Promise<any> => {
      return new Promise((resolve, reject) => {
        let config = window['menu'];
        let menuObj = groupBy(config, 'left_right');
        Promise.all([
          navigationService.getOrderedMenu(typeof menuObj.left === 'undefined' ? [] : menuObj.left),
          navigationService.getOrderedMenu(typeof menuObj.right === 'undefined' ? [] : menuObj.right)
        ]).then((data: any) => {
          navigationService.leftMenu = data[0];
          navigationService.rightMenu = data[1];
          let menus = [navigationService.leftMenu, navigationService.rightMenu];
          routingService.resetRouterConfig(menus);
          resolve(true);
        });
      });
    };
}

@NgModule({
  declarations: [
    AppComponent,
    ImageComponent,
    PageComponent,
    SplashPageComponent,
    NavBarComponent,
    HomeViewComponent,
    PosterImageComponent,
    HoverDirective,
    ProjectViewComponent,
    DefaultPageViewComponent,
    TableViewComponent,
    GridViewComponent,
    ThreeColViewComponent,
    ImageGalleryViewComponent,
    ContentBlocksComponent,
    SidebarComponent,
    PosterComponent,
    MessageOverlayComponent,
    ViewWithNavBarComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    InfiniteScrollModule,
    Ng2PageScrollModule.forRoot(),
    HttpModule
  ],
  providers: [
    requestOptionsProvider,
    NavigationService,
    ApiService,
    RoutingService,
    BreakpointsService,
    ImageGalleryService,
    LayoutService,
    CursorService,
    SplashService,
    { 
      provide: HAMMER_GESTURE_CONFIG, 
      useClass: MyHammerConfig 
    },
    {
      provide: APP_BOOTSTRAP_LISTENER,
      useFactory: init_app,
      deps: [RoutingService, NavigationService],
      multi: true
    }
  ],
  entryComponents: [
    DefaultPageViewComponent,
    ProjectViewComponent,
    GridViewComponent,
    ThreeColViewComponent,
    ImageGalleryViewComponent
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts